import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "react-querybuilder/dist/query-builder.css";
import { ECHO_ENDPOINT, PING_ENDPOINT } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import DeleteAlert from "../DeleteAlert";
import EchoAlert from "../EchoAlert";
import {
  FetchStudyHeaders,
  FilterTableHeader,
  pacsdataTableHeader,
  platformTableHeader,
  FetchServiceAccountHeaders,
} from "../Headers/HeadersConstant";
import "../HomeHeader.css";
import FilterDetailsModal from "../Modal/FilterDetailsModal";
import "../Modal/Modal.css";

export default function DataTable(props) {
  const {
    data,
    handlePage,
    count,
    totalPages,
    type,
    setAdd,
    setEditData,
    deleteAlert,
    setDeleteAlert,
    numberOfentries,
    totaldata,
    handleoption,
    setdeleteUpdate,
  } = props;

  const [modal, setModal] = useState(false);
  const [Query, setQuery] = useState();
  const [deleteID, setDeleteID] = useState(0);

  const [circularProgress, displayCircularProgress] = useState(false);
  const [circularEchoProgress, displayCircularEchoProgress] = useState(false);
  const [datasetId, setDatasetId] = useState("");
  const [progressElement, setProgressElement] = useState(-1);
  const [progressEchoElement, setProgressEchoElement] = useState(-1);
  const [pingstatus, setPingStatus] = useState("");
  const [echostatus, setEchoStatus] = useState("");
  const [echoAlert, setEchoAlert] = useState(false);

  useEffect(() => {
    if (circularProgress && pingstatus == "") {
      displayCircularProgress(true);
    } else {
      displayCircularProgress(false);
    }
  }, [pingstatus, circularProgress]);

  useEffect(() => {
    if (circularEchoProgress && echostatus == "") {
      displayCircularEchoProgress(true);
    } else {
      displayCircularEchoProgress(false);
    }
  }, [echostatus, progressEchoElement]);

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 15,
    },
  }));

  const handleModalOpen = () => {
    setModal(true);
  };

  const handleModalClose = () => {
    setModal(false);
    setEditData({});
  };

  const handleView = (value) => {
    setQuery(value);
    handleModalOpen();
  };

  const handleDelete = (id) => {
    setDeleteAlert(true);
    setDeleteID(id);
  };

  const handleEdit = (data) => {
    setAdd(true);
    setEditData(data);
  };

  const checkpingstatus = async (pingIP, ID) => {
    if (pingIP == "") {
      return;
    } else
      try {
        setProgressElement(pingIP);
        displayCircularProgress(true);
        setDatasetId(ID);
        const response = await axiosInstance.post(
          `${PING_ENDPOINT}`,
          {
            url: pingIP,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setPingStatus(response.data.message);
        setEchoAlert(true);
      } catch (error) {
        setPingStatus("some internal error occured");
      }
  };

  const checkEchoStatus = async (ip, ae_title, port) => {
    try {
      setProgressEchoElement(ae_title);
      displayCircularEchoProgress(true);
      const response = await axiosInstance.post(
        `${ECHO_ENDPOINT}`,
        {
          ip: ip,
          port: port,
          ae_title: ae_title,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      setEchoStatus(response.data.message);
      setEchoAlert(true);
    } catch (error) {
      setEchoStatus("some internal error occured");
    }
  };

  return (
    <div>
      <div>
        <div className="d-flex flex-column">
          <div>
            <table
              className="styled-table"
              style={{
                marginTop:
                  type === "platformTable" || type === "serviceAccountTable"
                    ? "0px"
                    : "",
              }}
            >
              <thead>
                {type === "platformTable" && (
                  <tr>
                    {/* <th>SR.No</th> */}
                    {platformTableHeader.map((header, i) => {
                      return <th>{header}</th>;
                    })}
                    <th>Ping</th>
                    <th>Actions</th>
                  </tr>
                )}
                {type === "filtertable" && (
                  <tr>
                    {/* <th>SR.No</th> */}
                    {FilterTableHeader.map((header) => (
                      <th>{header}</th>
                    ))}
                    <th>Actions</th>
                  </tr>
                )}
                {type === "PacsTable" && (
                  <tr>
                    {/* <th>SR.No</th> */}
                    {pacsdataTableHeader.map((header) => (
                      <th>{header}</th>
                    ))}
                    <th>Echo</th>
                    <th>Actions</th>
                  </tr>
                )}
                {type === "fetchStudyTable" && (
                  <tr>
                    {/* <th>SR. No.</th> */}
                    {FetchStudyHeaders.map((header) => (
                      <th>{header}</th>
                    ))}
                  </tr>
                )}
                {type === "serviceAccountTable" && (
                  <tr>
                    {FetchServiceAccountHeaders.map((header) => (
                      <th key={header}>{header}</th>
                    ))}
                  </tr>
                )}
              </thead>
              {props.data && props.data.length > 0 ? (
                <tbody>
                  {type === "platformTable" &&
                    props.data.map((data, index) => (
                      <tr key={index} className="styled-table">
                        {/* <td>{index + 1 + (count - 1) * 10}</td> */}
                        <td>{data?.name}</td>
                        <td>{data?.ip}</td>
                        <td>{data?.rpc_url}</td>
                        <td>{data?.dataset_id}</td>
                        <td>{data?.platform_user_id}</td>

                        <td>
                          {circularProgress &&
                            datasetId == data["dataset_id"] && (
                              <CircularProgress
                                style={{
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            )}
                          {(!circularProgress ||
                            datasetId != data["dataset_id"]) && (
                            <button
                              className="btn-class"
                              style={{ marginTop: "0px" }}
                              onClick={() =>
                                checkpingstatus(data["ip"], data["dataset_id"])
                              }
                            >
                              PING
                            </button>
                          )}
                          <EchoAlert
                            echoAlert={echoAlert}
                            setEchoAlert={setEchoAlert}
                            type="PLATFORM"
                            value={progressElement}
                            result={pingstatus}
                            setPingStatus={setPingStatus}
                          />
                        </td>
                        <td>
                          <BootstrapTooltip title="Delete">
                            <IconButton>
                              <DeleteIcon
                                onClick={() => handleDelete(data.id)}
                                style={{ color: "white", cursor: "pointer" }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                          {deleteAlert && (
                            <DeleteAlert
                              type={type}
                              id={deleteID}
                              deleteAlert={deleteAlert}
                              setDeleteAlert={setDeleteAlert}
                              handlePage={handlePage}
                              count={count}
                              data={props.data}
                              setdeleteUpdate={setdeleteUpdate}
                            />
                          )}
                          &nbsp;
                          <BootstrapTooltip title="Edit">
                            <IconButton>
                              <ModeEditIcon
                                onClick={() => handleEdit(data)}
                                style={{ color: "white", cursor: "pointer" }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                        </td>
                      </tr>
                    ))}
                  {type === "filtertable" &&
                    props.data.map((data, index) => (
                      <tr key={index} className="styled-table">
                        {/* <td>{index + 1 + (count - 1) * 10}</td> */}
                        <td>{data.name}</td>
                        <td>
                          <i
                            className="fa fa-eye"
                            onClick={() => handleView(data.filters)}
                            Tooltip="view"
                          ></i>
                        </td>
                        <td>
                          <BootstrapTooltip title="Delete">
                            <IconButton>
                              <DeleteIcon
                                onClick={() => handleDelete(data.id)}
                                style={{ color: "white", cursor: "pointer" }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                          {deleteAlert && (
                            <DeleteAlert
                              data={props.data}
                              type={type}
                              id={deleteID}
                              deleteAlert={deleteAlert}
                              setDeleteAlert={setDeleteAlert}
                              handlePage={handlePage}
                              count={count}
                              setdeleteUpdate={setdeleteUpdate}
                            />
                          )}
                          &nbsp;
                          <BootstrapTooltip title="Edit">
                            <IconButton>
                              <ModeEditIcon
                                onClick={() => handleEdit(data)}
                                style={{ color: "white", cursor: "pointer" }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                        </td>
                      </tr>
                    ))}
                  {type === "PacsTable" &&
                    Object.values(props.data).map((data, index) => (
                      <tr key={index}>
                        {Object.values(data)
                          .filter((value, index) => index !== 0)
                          .map((d, i) => (
                            <td key={i}>
                              {d?.toString() !== ""
                                ? d?.toString()
                                : "Not mentioned"}
                            </td>
                          ))}
                        <td>
                          {circularEchoProgress &&
                            progressEchoElement == data["ae_title"] && (
                              <CircularProgress
                                style={{
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            )}
                          {(!circularEchoProgress ||
                            progressEchoElement != data["ae_title"]) && (
                            <button
                              className="btn-class"
                              style={{ marginTop: "0px" }}
                              onClick={() =>
                                checkEchoStatus(
                                  data["ip"],
                                  data["ae_title"],
                                  data["port"]
                                )
                              }
                            >
                              ECHO
                            </button>
                          )}
                          <EchoAlert
                            echoAlert={echoAlert}
                            setEchoAlert={setEchoAlert}
                            type="C-ECHO"
                            value={progressEchoElement}
                            result={echostatus}
                            setPingStatus={setEchoStatus}
                          />
                        </td>

                        <td>
                          <BootstrapTooltip title="Delete">
                            <IconButton>
                              <DeleteIcon
                                onClick={() => handleDelete(data.id)}
                                style={{ color: "white", cursor: "pointer" }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                          {deleteAlert && (
                            <DeleteAlert
                              type={type}
                              id={deleteID}
                              deleteAlert={deleteAlert}
                              setDeleteAlert={setDeleteAlert}
                              handlePage={handlePage}
                              count={count}
                              data={props.data}
                              setdeleteUpdate={setdeleteUpdate}
                            />
                          )}
                          &nbsp;{" "}
                          <BootstrapTooltip title="Edit">
                            <IconButton>
                              <ModeEditIcon
                                onClick={() => handleEdit(data)}
                                style={{ color: "white", cursor: "pointer" }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                        </td>
                      </tr>
                    ))}
                  {type === "fetchStudyTable" &&
                    Object.values(props.data).map((data, index) => (
                      <tr key={index}>
                        {Object.values(data).map((d, i) => (
                          <td key={i}>
                            {d?.toString() !== "" ? d?.toString() : ""}
                          </td>
                        ))}
                      </tr>
                    ))}
                  {type === "serviceAccountTable" &&
                    props.data.map((data, index) => (
                      <tr key={index} className="styled-table">
                        <td>{data?.email_id}</td>
                        <td>{data?.platform_url}</td>
                      </tr>
                    ))}
                </tbody>
              ) : (
                <tr>
                  <td colSpan="12" className="text-center font-weight-bold">
                    No Records Found
                  </td>
                </tr>
              )}
            </table>
          </div>
          {type === "fetchStudyTable" && props.data && props.data.length > 0 ? (
            <div className="d-flex justify-content-between pb-5 mt-2">
              <div
                style={{ color: "white", marginLeft: "7rem", fontSize: "14px" }}
              >
                <div>
                  <span>Show </span>
                  <select
                    className="entries-select"
                    onChange={(e) => handleoption(e)}
                    value={numberOfentries}
                  >
                    {[25, 50, 75, 100].map((pageSize) => (
                      <option
                        key={pageSize}
                        value={pageSize}
                        style={{ color: "#82024" }}
                      >
                        {pageSize}
                      </option>
                    ))}
                  </select>
                  <span>Entries </span>
                </div>
                {`Showing ${
                  numberOfentries * count - (numberOfentries - 1)
                } to ${
                  numberOfentries * count > totaldata
                    ? totaldata
                    : numberOfentries * count
                } of ${totaldata} Entries`}
              </div>
              {props.data && props.data.length > 0 ? (
                <div className="d-flex justify-content-end pb-5">
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages && totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    forcePage={count && count - 1} //{entityList.number}
                    onPageChange={(e) => handlePage(e.selected)}
                    containerClassName="pagination"
                    subContainerClassName="pages pagination"
                    activeClassName="active"
                    previousLinkClassName="pagination-link"
                    nextLinkClassName="pagination-link"
                    breakLinkClassName="pagination-link"
                    pageLinkClassName="pagination-link"
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : props.data && props.data.length > 0 ? (
            <div className="d-flex justify-content-end pb-5 pt-2">
              <ReactPaginate
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                breakClassName="break-me"
                pageCount={totalPages && totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                forcePage={count && count - 1}
                onPageChange={(e) => handlePage(e.selected)}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
                previousLinkClassName="pagination-link"
                nextLinkClassName="pagination-link"
                breakLinkClassName="pagination-link"
                pageLinkClassName="pagination-link"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>

      {modal && (
        <FilterDetailsModal
          handleModalClose={handleModalClose}
          Query={Query}
          modal={modal}
        />
      )}
    </div>
  );
}
